module.exports = __webpack_public_path__ + "img/completed.52b7df05.svg";